export default {
      id: "coin-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#coin",
      toString: function () {
        return this.url;
      }
    }